import React from 'react';
import { Button, Modal } from 'antd';
import { useUpdateBugFeatureStatus } from 'mutation/admin';
import { BUG_FEATURE_STATUS } from 'components/blocks/BugFeatureReportForm/useBugFeatureForm';

export default function UpdateBugFeatureStatusButton({
  dataId,
  type,
  nextStatus,
  children,
  ...rest
}) {
  const { mutate, isLoading } = useUpdateBugFeatureStatus();

  const onConfirmAction = () => {
    Modal.confirm({
      title: 'Confirmation',
      content: getConfirmationMessage(nextStatus, type),
      okText: 'Yes',
      okType: 'primary',
      onOk: () => handleClick(),
      cancelText: 'No',
    });
  };

  const handleClick = () => {
    mutate({ status: nextStatus, id: dataId });
  };

  return (
    <Button {...rest} loading={isLoading} onClick={onConfirmAction}>
      {children}
    </Button>
  );
}

const getConfirmationMessage = (nextStatus, type = 'Item') => {
  if (nextStatus === BUG_FEATURE_STATUS.CLOSED)
    return `Confirm to close this ${type}`;

  if (nextStatus === BUG_FEATURE_STATUS.IN_PROGRESS)
    return `Confirm to move this ${type} to "In-Progress"`;

  return 'Are you sure?';
};
